import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@ui/icon/icon.component';

@Component({
  selector: 'app-image-viewer',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center">
      <div class="relative max-w-7xl w-full mx-4">
        <!-- Close button -->
        <button
          (click)="close.emit()"
          class="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
        >
          <ui-icon name="close" class="w-6 h-6" />
        </button>

          <!-- Image -->
        <div class="relative aspect-video">
          <img
            [src]="images[currentIndex()].url"
            [alt]="images[currentIndex()].label"
            class="w-full h-full object-contain"
          />
        </div>

        <!-- Navigation buttons -->
        <button
          *ngIf="currentIndex() > 0"
          (click)="previousImage()"
          class="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300"
        >
          <ui-icon name="chevron-left" class="w-8 h-8" />
        </button>

        <button
          *ngIf="currentIndex() < images.length - 1"
          (click)="nextImage()"
          class="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300"
        >
          <ui-icon name="chevron-right" class="w-8 h-8" />
        </button>



        <!-- Image label -->
        <div class="text-center text-white mt-4">
          {{ images[currentIndex()].label }}
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ImageViewerComponent {
  @Input({ required: true }) images!: Array<{ url: string; label: string }>;
  @Input() initialIndex = 0;
  @Output() close = new EventEmitter<void>();

  currentIndex = signal(0);

  ngOnInit() {
    this.currentIndex.set(this.initialIndex);
  }

  previousImage() {
    console.log('previousImage');
    if (this.currentIndex() > 0) {
      this.currentIndex.update(index => index - 1);
    }
  }

  nextImage() {
    console.log('nextImage');
    if (this.currentIndex() < this.images.length - 1) {
      this.currentIndex.update(index => index + 1);
    }
  }
}
